import { customAlphabet, urlAlphabet } from 'nanoid';
const nanoid = customAlphabet(urlAlphabet);
export const randomId = () => nanoid();
//# sourceMappingURL=randomId.js.map